import { render, staticRenderFns } from "./ReferenceUnitPage.vue?vue&type=template&id=38b50cb8"
import script from "./ReferenceUnitPage.vue?vue&type=script&lang=js"
export * from "./ReferenceUnitPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports